module.exports = __webpack_public_path__ + "static/media/limechat.255fb957.webp";